// extracted by mini-css-extract-plugin
export default {"fullWidth":"Tl-z","image":"Ul-z","lazyLoadPicture":"Vl-z","lazyLoadSpinner":"Wl-z","lazyLoadSpin":"Xl-z","lazyLoadImage":"Yl-z","hasStyledAspectRatio":"Zl-z"};